// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Button from "@insite/mobius/Button";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { DLSectionTitle, SectionContainer } from "@werner/App/Widgets/DesignSystem/DesignSystem.helpers";
import { longText } from "@werner/App/Widgets/DesignSystem/DummyData/DummyData";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

interface ToastTabStyles {
    titleGridItem?: GridItemProps;
    gridItem?: GridItemProps;
    toastWrapper?: InjectableCss;
}

const toastTabStyles: ToastTabStyles = {
    titleGridItem: {
        width: 12,
    },
    gridItem: {
        width: 12,
        css: css`
            flex-wrap: wrap;
            padding-bottom: 40px;
        `,
    },
    toastWrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin-top: 20px;
            flex-wrap: wrap;
        `,
    },
};

const styles = toastTabStyles;
const ToastTab: FC = props => {
    const toasterContext = useContext(ToasterContext);

    return (
        <SectionContainer>
            <GridItem {...styles.titleGridItem}>
                <DLSectionTitle>{translate("Toast")}</DLSectionTitle>
            </GridItem>
            <GridItem {...styles.gridItem}>
                <StyledWrapper {...styles.toastWrapper}>
                    <Button
                        color="success"
                        onClick={() =>
                            toasterContext.addToast({
                                title: "Toast - Success",
                                body: "Success",
                                messageType: "success",
                            })
                        }
                    >
                        Success
                    </Button>

                    <Button
                        color="danger"
                        onClick={() =>
                            toasterContext.addToast({ title: "Toast - Danger", body: "Danger", messageType: "danger" })
                        }
                    >
                        Danger
                    </Button>
                    <Button
                        color="info"
                        onClick={() =>
                            toasterContext.addToast({ title: "Toast - Info", body: "Info", messageType: "info" })
                        }
                    >
                        Info
                    </Button>
                    <Button
                        color="warning"
                        onClick={() =>
                            toasterContext.addToast({
                                title: "Toast - Warning",
                                body: "Warning",
                                messageType: "warning",
                            })
                        }
                    >
                        Warning
                    </Button>
                    <Button
                        onClick={() =>
                            toasterContext.addToast({
                                title: "Toast - title",
                                body: "message",
                                messageType: "success",
                            })
                        }
                    >
                        Short Message - Toast
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={() =>
                            toasterContext.addToast({
                                title: "Toast - title",
                                body: longText,
                                messageType: "success",
                                timeoutLength: 500000,
                            })
                        }
                    >
                        Long Message - Toast
                    </Button>
                </StyledWrapper>
            </GridItem>
        </SectionContainer>
    );
};

export default ToastTab;
